import styled from "styled-components";

export const StyledDescription = styled.div`
    font-size: var(--size-16);
    color: var(--color-grey-900);
`;
